import React from 'react';
import PropTypes from 'prop-types';

import { SelectBox } from 'components/core/SelectBox';

// REDUX-FORM SELECT BOX
export default function ReduxSelectBox({
	className,
	input,
	label,
	meta,
	disabled,
	options,
	id,
	errorMessage
}) {
	return (
		<SelectBox
			{...input}
			id={id}
			className={className}
			valid={meta.valid}
			options={options}
			disabled={disabled}
			label={label}
			reduxFormError={meta.touched && meta.invalid}
			errorMessage={errorMessage}
		/>
	);
}

ReduxSelectBox.propTypes = {
	label: PropTypes.string,
	input: PropTypes.object,
	className: PropTypes.string,
	meta: PropTypes.object,
	disabled: PropTypes.bool,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.any,
			display: PropTypes.string
		})
	),
	id: PropTypes.string,
	value: PropTypes.string,
	errorMessage: PropTypes.string
};
